import { EMITTER_PROPS } from './constants'

const emitterProps = EMITTER_PROPS

class GlobalEmitter {
  emit(name, payload) {
    if (typeof name !== 'string') {
      throw new Error('Event name must be a string')
    }

    const event = new CustomEvent(name, {
      detail: payload
    })

    document.dispatchEvent(event)
  }

  on(name, callback) {
    if (typeof name !== 'string' || typeof callback !== 'function') {
      throw new Error(
        'Event name must be a string and callback must be a function'
      )
    }

    document.addEventListener(name, (e) => {
      callback(e.detail)
    })
  }

  off(name, callback) {
    if (typeof name !== 'string' || typeof callback !== 'function') {
      throw new Error(
        'Event name must be a string and callback must be a function'
      )
    }

    document.removeEventListener(name, callback)
  }
}

const globalEmitter = new GlobalEmitter()

export { emitterProps, globalEmitter }
